import UAParser from 'ua-parser-js';
import { toJS } from 'mobx';

export function metadata() {
  // screen
  let screenSize = '';

  if (window.screen.width && window.screen.height) {
    screenSize = `${window.screen.width} x ${window.screen.height}`;
  }

  // cookie
  let cookieEnabled = !!window.navigator.cookieEnabled;
  if (!cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
  }

  // flash (you'll need to include swfobject)
  const flashVersion = 'no check';

  const sniffedAgent = new UAParser();
  const ua = sniffedAgent.getResult();

  return {
    screen: screenSize,
    browser: ua.browser.name,
    browserVersion: ua.browser.version,
    mobile: ua.device.type === 'mobile',
    os: ua.os.name,
    osVersion: ua.os.version,
    cookies: cookieEnabled,
    flashVersion,
  };
}

export function debugInfo(url, user) {
  let body = '';
  const rawDebug = {};
  const info = metadata();

  if (typeof url !== 'undefined') {
    // legacy, who knows
    body = `${body}URL: ${url}`;
    rawDebug.url = url;
  }

  body = `${body}
OS: ${info.os} ${info.osVersion}
Browser: ${info.browser} ${info.browserVersion}
Mobile: ${info.mobile}
Cookies: ${info.cookies}
Screen Size: ${info.screen || 'unavailable'}
`;
  rawDebug.os = `${info.os} ${info.osVersion}`;
  rawDebug.browser = `${info.browser} ${info.browserVersion}`;
  rawDebug.mobile = `${info.mobile}`;
  rawDebug.cookies = `${info.cookies}`;
  rawDebug.screenSize = `${info.screen || 'unavailable'}`;

  const { firstname, lastname, email, authenticated, traits, groups } = user;

  if (authenticated && traits !== false) {
    body = `${body}

User Info
`;

    const ui = {
      'First Name': firstname,
      'Last Name': lastname,
      Email: email,
      Groups: groups,
    };

    const userInfo = Object.assign({}, ui, toJS(traits));

    Object.keys(userInfo).forEach(name => {
      const value = userInfo[name];

      if (typeof value !== 'undefined') {
        body = `${body}${name}: ${value}
`;
      }
    });
  }
  return {
    body,
    debug: rawDebug,
  };
}

export default debugInfo;



// WEBPACK FOOTER //
// ./src/utils/debug.js